/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPointerDown = createReactComponent("pointer-down", "IconPointerDown", [
  [
    "path",
    {
      d: "M15.992 13.436l-1.214 -1.214l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.171 1.171",
      key: "svg-0"
    }
  ],
  ["path", { d: "M19 16v6", key: "svg-1" }],
  ["path", { d: "M22 19l-3 3l-3 -3", key: "svg-2" }]
]);

export { IconPointerDown as default };
//# sourceMappingURL=IconPointerDown.js.map
